var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconButtonDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99984 12.4444C1.99984 13.3 2.74984 14 3.6665 14H10.3332C11.2498 14 11.9998 13.3 11.9998 12.4444V3.11111H1.99984V12.4444ZM12.8332 0.777778H9.9165L9.08317 0H4.9165L4.08317 0.777778H1.1665V2.33333H12.8332V0.777778Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconButtonDelete);
export default __webpack_public_path__ + "static/media/icon_button_delete.ba68d5f5595880ce00d0f6dfc3c93921.svg";
export { ForwardRef as ReactComponent };